var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": `payment-group:${_vm.dataQa}` } },
    [
      _vm.isCollapsible
        ? _c(
            "div",
            {
              staticClass: "_tc--accent _mt-1 _ml-1 _select-none",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggle")
                },
              },
            },
            [
              _vm.isCollapsed
                ? _c(
                    "div",
                    { staticClass: "_flex _cur-p" },
                    [
                      _c("base-icon", {
                        staticClass: "_mr-1",
                        attrs: { name: "chevron-down" },
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.collapsedTitle) +
                          "\n        "
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "_flex _cur-p" },
                    [
                      _c("base-icon", {
                        staticClass: "_mr-1",
                        attrs: { name: "chevron-up" },
                      }),
                      _vm._v(
                        "\n            " + _vm._s(_vm.title) + "\n        "
                      ),
                    ],
                    1
                  ),
            ]
          )
        : _vm.isTitleVisible
        ? _c(
            "base-heading",
            { staticClass: "_mt-2", attrs: { tag: "h4", variant: "light" } },
            [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCollapsible || !_vm.isCollapsed
        ? _c("div", [_vm._t("default")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }